import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/profile/customers",
		component: lazy(() => import("./CustomersPage")),
	},
]);
